import { Theme, ThemeName } from '@/types/theme';
import BrandliveLogo from './brandlive/brandlive-logo';
import BrandliveBackdrop from './brandlive/brandlive-backdrop/brandlive-backdrop';

const brandlive: Theme = {
  name: ThemeName.BRANDLIVE,
  backdrop: {
    component: BrandliveBackdrop,
  },
  logo: BrandliveLogo,
};

export default brandlive;
